// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"535":"3381ecd2","744":"a539ff81","879":"5f29e8bc"}[chunkId] + ".js";
};